import React from 'react'

const Main = () => {
  return (
    <div className="flex flex-col justify-center items-center w-full h-screen">
      <div className={`flex flex-col justify-center items-center w-full h-full grass`}>
        
      </div>
    </div>
  )
}

export default Main